import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // userInfo: any;
  profileData: any;
  // currentUser: any;
  jwtToken: any;

  constructor(
    private authenticationService: AuthService
  ) {
    // this.userInfo = localStorage.getItem('currentUser') || '{}';
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.headers.has('Authorization')) {
      this.jwtToken = this.authenticationService.currentUserValue;
      req = req.clone({
        headers: req.headers
          .set('Authorization', 'Bearer ' + this.jwtToken)
          .set('Content-Disposition', 'application/json'),
      });
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.authenticationService.logout();
        }
        return throwError(() => error);
      })
    );
  }
}
